document.addEventListener("DOMContentLoaded", function () {
  let sliderValue = 1000;
  let deviceValue = 235;
  let devicePerWeek = 7;
  let weeks = 36;
  let totalBrokenDevice = 220;
  let activeDeviceType = document.querySelector('.device-icon.active')?.parentElement.dataset.id;
  let selectedCase = document.querySelector('.case-type').value;
  const deviceImagesData = document.querySelector('#device-images');
  const deviceImages = JSON.parse(deviceImagesData.dataset.images);

  // var totalDevices = 1000;
  document.querySelectorAll('.icons-container .icon-item').forEach(icon => {
    icon.addEventListener('click', function () {
      document.querySelectorAll('.icons-container .icon-item').forEach(i => i.classList.remove('active'));
      this.classList.add('active');
    });
  });

  document.querySelectorAll('.step-right .devices-type .device-icon').forEach(icon => {
    icon.addEventListener('click', function () {
      document.querySelectorAll('.step-right .devices-type .device-icon').forEach(i => i.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // document.querySelector('.cost-input').addEventListener('change', function() {
  //   document.querySelector('.calculated-average-cost-text').innerHTML = `$${deviceValue}`;
  // });

  // validation
  document.querySelectorAll('.cost-input').forEach(inputField => {
    inputField.addEventListener('keyup', function () {
      let input = this.value;
      let errorMessage = document.querySelector('#error-message');

      if (/^[0-9]{1,3}$/.test(input) || input === "") {
        console.log("working");
      } else {
        this.value = input.slice(0, -1);
        console.log('Please enter a valid 1-3 digit integer.');
      }
    });
  });

  document.querySelectorAll('.devices-type a').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      deviceValue = this.getAttribute('device-value');
      let id = this.dataset.id;

      if (selectedCase === "Rugged Snap-On Case") {
        if (id == 1 || id == 2) {
          document.querySelector('#protect-img').src = deviceImages.rugged_small;
        } else if (id == 3) {
          document.querySelector('#protect-img').src = deviceImages.sleeve_small;
        }
      } else if (selectedCase === "Protective Sleeve") {
        if (id == 1 || id == 2) {
          document.querySelector('#protect-img').src = deviceImages.rugged_large;
        } else if (id == 3) {
          document.querySelector('#protect-img').src = deviceImages.sleeve_large;
        }
      }

      document.querySelector('.calculated-average-cost input').value = deviceValue;
      // document.querySelector('.calculated-average-cost-text').innerHTML = `$${deviceValue}`;
      calculateSavings();
    });
  });

  document.querySelector('.slider-range #devices').addEventListener('input', function () {
    sliderValue = this.value;

    document.querySelector('.slider .unit-value').textContent = sliderValue;

    totalBrokenDevice = (sliderValue * 22) / 100;

    calculateSavings(true);
  });

  document.querySelector('#avg-cost').addEventListener('change', function () {
    let averageCost = parseInt(this.value);
    deviceValue = averageCost;

    // document.querySelector('.calculated-average-cost-text').innerHTML = `$${averageCost}`;
    calculateSavings();
  });

  document.querySelector('#broken-device').addEventListener('change', function () {
    let brokenDevice = parseInt(this.value);
    devicePerWeek = brokenDevice;

    calculateSavings();
  });

  document.querySelector('#weeks').addEventListener('change', function () {
    weeks = parseInt(this.value);

    calculateSavings();
  });

  document.querySelector('.case-type').addEventListener('change', function () {
    selectedCase = this.value;
    activeDeviceType = document.querySelector('.device-icon.active')?.dataset.id;

    if (selectedCase === "Rugged Snap-On Case") {
      if (activeDeviceType == 1 || activeDeviceType == 2) {
        document.querySelector('#protect-img').src = deviceImages.rugged_small;
      } else if (activeDeviceType == 3) {
        document.querySelector('#protect-img').src = deviceImages.sleeve_small;
      }
    } else if (selectedCase === "Protective Sleeve") {
      if (activeDeviceType == 1 || activeDeviceType == 2) {
        document.querySelector('#protect-img').src = deviceImages.rugged_large;
      } else if (activeDeviceType == 3) {
        document.querySelector('#protect-img').src = deviceImages.sleeve_large;
      }
    }
    // calculateSavings();
  });

  function calculateSavings(fromSlider = false) {
    if (!sliderValue || !deviceValue) {
      return;
    }

    devicePerWeek = parseInt(document.querySelector('#broken-device').value);

    let totalProtectionCost = 25 * sliderValue;
    let weeklyBrokenDevice = devicePerWeek;

    if (fromSlider) {
      weeklyBrokenDevice = totalBrokenDevice / weeks;
    } else {
      totalBrokenDevice = weeklyBrokenDevice * weeks;
    }

    // let totalBrokenDevice = (sliderValue * 22) / 100;

    let recoveredTime = (totalBrokenDevice * 0.25) * 4;
    let totalSavings = ((totalBrokenDevice * 3) * deviceValue) - ((((totalBrokenDevice * 0.7) * 3) * deviceValue) + totalProtectionCost);

    document.querySelector(".cost-per-case").innerHTML = Math.ceil(totalBrokenDevice);
    document.querySelector(".total-broken-device input").value = Math.ceil(weeklyBrokenDevice);
    document.querySelector(".total-savings").textContent = `$${Math.ceil(totalSavings).toLocaleString()}`;
    document.querySelector(".recovered-time").textContent = `${Math.ceil(recoveredTime)} hrs`;
    document.querySelector(".recovered-time-text").textContent = Math.ceil(recoveredTime);
  }

  calculateSavings(true);
});
